import { useEffect, useRef } from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";

interface AnimatedCounterProps {
  value: number;
  className?: string;
  suffix?: string;
  prefix?: string;
}

const AnimatedCounter = ({ value, className, suffix, prefix }: AnimatedCounterProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, { damping: 60, stiffness: 200 });
  const isInView = useInView(ref, { margin: "0px", once: false });

  useEffect(() => {
    if (isInView) {
      motionValue.set(0);
      requestAnimationFrame(() => {
        motionValue.set(value);
      });
    } else {
      // Reset to 0 when out of view so it re-animates on next scroll
      motionValue.set(0);
    }
  }, [isInView, value, motionValue]);

  useEffect(() => {
    const unsubscribe = springValue.on("change", (latest) => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat("en-US").format(
          Math.round(latest)
        );
      }
    });
    return unsubscribe;
  }, [springValue]);

  return (
    <div className={className}>
      {prefix}<span ref={ref} />
      {suffix}
    </div>
  );
};

export default AnimatedCounter;
